import { useMediaQuery } from '@mui/material'

function useIsMobileBreakpoint() {
  return useMediaQuery((theme) => theme.breakpoints.only('xs'))
}

export default useIsMobileBreakpoint
